module.exports = __webpack_public_path__ + "494cd07c/img/saly-icon.39e12342.jpg";